
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import GrandOpening from './components/GrandOpening';
import About from './components/About';
import Ingredients from './components/Ingredients';
import Contact from './components/Contact';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <GrandOpening />
      <About />
      <Ingredients />
      <Contact />
      <Footer />
    </div>
  );
}
